import React from "react";
const NotFound: React.FC = () => <h2>404 - Page Not Found</h2>;
export default NotFound;
